"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PopoverContextProvider = exports.PlacerContextConsumer = exports.PopoverContext = exports.PopoverContextValue = void 0;
const react_1 = __importStar(require("react"));
const react_dom_1 = require("react-dom");
const helpers_1 = require("../helpers");
class PopoverContextValue {
    constructor() {
        this.portalDomNode = null;
        this.getPortalDOMNode = () => {
            if (!this.portalDomNode) {
                this.portalDomNode = (0, helpers_1.createPortalDomNode)();
                if (!this.portalDomNode) {
                    return null;
                }
                document.body.appendChild(this.portalDomNode);
            }
            return this.portalDomNode;
        };
    }
}
exports.PopoverContextValue = PopoverContextValue;
exports.PopoverContext = (0, react_1.createContext)(new PopoverContextValue());
exports.PlacerContextConsumer = exports.PopoverContext.Consumer;
class PopoverContextProvider extends react_1.Component {
    constructor() {
        super(...arguments);
        this.portalDomNode = null;
        this.getPortalDOMNode = () => {
            if (!this.portalDomNode) {
                this.portalDomNode = (0, helpers_1.createPortalDomNode)();
                if (!this.portalDomNode) {
                    return null;
                }
                // eslint-disable-next-line react/no-find-dom-node
                const selfDOMNode = (0, react_dom_1.findDOMNode)(this);
                if (selfDOMNode) {
                    if (selfDOMNode.parentNode && selfDOMNode.parentNode instanceof HTMLElement) {
                        const parentDOMNode = selfDOMNode.parentNode;
                        const originalPosition = parentDOMNode.style.position;
                        parentDOMNode.style.position = 'relative';
                        parentDOMNode.appendChild(this.portalDomNode);
                        const originRemove = this.portalDomNode.remove.bind(this.portalDomNode);
                        this.portalDomNode.remove = () => {
                            parentDOMNode.style.position = originalPosition;
                            originRemove();
                        };
                        return this.portalDomNode;
                    }
                }
                document.body.appendChild(this.portalDomNode);
            }
            return this.portalDomNode;
        };
    }
    render() {
        return react_1.default.createElement(exports.PopoverContext.Provider, { value: this }, this.props.children);
    }
}
exports.PopoverContextProvider = PopoverContextProvider;
//# sourceMappingURL=PopoverContext.js.map